import Logo1 from "assets/images/logo.jpg";
import { FaUserAlt } from "react-icons/fa";
import { Link, NavLink, useNavigate } from "react-router-dom";
import whatsApp from "../assets/svgs/whatsApp.svg";
const Header = () => {
  const navigate = useNavigate();
  return (
    <>
      <header className="sticky top-0 z-50 bg-white">
        <div className="bg-blackColor2 dark:bg-lightGrey10-dark hidden lg:block">
          <div className="lg:container 3xl:container2-lg 4xl:container mx-auto text-whiteColor text-size-12 xl:text-sm py-5px xl:py-9px">
            <div className="flex justify-between items-center">
              <div>
                <p>
                  Call Us: <a href="tel:+18884507104">+1 888 450 7104</a> - Mail
                  Us: <a href="mailto:help@metordy.com">help@metordy.com</a>
                </p>
              </div>
              <div className="flex gap-37px items-center">
                <div>
                  <p>
                    <i className="icofont-location-pin text-primaryColor text-size-15 mr-5px capitalize"></i>
                    <span>
                      Hamsa building - Khalid bin Al Waleed Rd - Al Karma Dubai
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="transition-all duration-500 sticky-header z-medium dark:bg-whiteColor-dark py-6">
          <nav>
            <div className="py-15px lg:py-0 px-15px lg:container 3xl:container2-lg 4xl:container mx-auto relative">
              <div className="grid grid-cols-2 lg:grid-cols-12 items-center gap-15px">
                <div className="lg:col-start-1 lg:col-span-2">
                  <Link to="/" className="block">
                    <img src={Logo1} alt="Logo" className="w-[130px] py-2" />
                  </Link>
                </div>
                <div className="hidden lg:block lg:col-start-3 lg:col-span-8">
                  <ul className="nav-list flex justify-center whitespace-nowrap">
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/coming-soon"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Our Story
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/coming-soon"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Our Solutions
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/coming-soon"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Students
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/coming-soon"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Parents
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/about-us"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Partners
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/about-us"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Scheduling Counselling
                      </NavLink>
                    </li>
                    <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/about-us"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Contact Us
                      </NavLink>
                    </li>

                    {/* <li className="nav-item group relative cursor-pointer">
                      <NavLink
                        to="/courses"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        Courses
                      </NavLink>
                    </li> */}
                    {/* <li className="nav-item group relative cursor-pointer">
                    <NavLink
                        to="/about-us"
                        className="px-5 lg:px-10px 2xl:px-15px 3xl:px-5 py-10 lg:py-5 2xl:py-30px 3xl:py-10 leading-sm 2xl:leading-lg text-base lg:text-sm 2xl:text-base font-semibold block group-hover:text-primaryColor dark:text-whiteColor"
                      >
                        <img src={whatsApp} alt="Contact Us Icon" className="mr-2 h-38 w-38" />
                      </NavLink>
                    </li> */}
                  </ul>
                </div>
                <div className="lg:col-start-11 lg:col-span-2">
                  <ul className="relative nav-list flex justify-end items-center">
                    <li className="hidden lg:block">
                      <span className="px-15px py-3 ">
                        <img
                          src={whatsApp}
                          alt="Contact Us Icon"
                          className=""
                        />
                      </span>
                    </li>
                    <li
                      className="hidden lg:block"
                      onClick={() => navigate("/signup")}
                    >
                      <span className="text-size-12 2xl:text-size-15 px-15px py-3 text-blackColor hover:text-whiteColor bg-whiteColor block hover:bg-primaryColor border border-borderColor1 rounded-standard font-semibold mr-[7px] 2xl:mr-15px dark:text-blackColor-dark dark:bg-whiteColor-dark dark:hover:bg-primaryColor dark:hover:text-whiteColor dark:hover:border-primaryColor">
                        <i className="icofont-user-alt-5"></i>
                        <FaUserAlt />
                      </span>
                    </li>
                    <li className="hidden lg:block">
                      <span className="text-size-12 2xl:text-size-15 text-whiteColor bg-primaryColor block border-primaryColor border hover:text-primaryColor hover:bg-white px-15px py-2 rounded-standard dark:hover:bg-whiteColor-dark dark: dark:hover:text-whiteColor">
                        Get Start
                      </span>
                    </li>
                    <li className="block lg:hidden">
                      <button className="open-mobile-menu text-3xl text-darkdeep1 hover:text-secondaryColor dark:text-whiteColor dark:hover:text-secondaryColor">
                        <i className="icofont-navigation-menu"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
